import React from "react";

const LayoutBody1 = props => (
  <div className="layout-body layout-body-1">
    <div className="container">
	    <div className="row layout-content">
	  		<div className="col-xs-12 col-lg-8 text">
          <h1>{props.title}</h1>
        </div>
      </div>
    </div>
  </div>
);

export default LayoutBody1;
